export default "__VITE_ASSET__BZ2NY9Vi__"